import {
  Button,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Box,
  Modal,
  ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon,
} from "../../../common/utils/mui-imports";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import HPRTextBox from "../../../components/common/HPRTextBox/HPRTextBox";
import { EnumTextBoxType } from "../../../components/common/HPRTextBox/HPRTextBox.enum";
import {
  SubjectPageParametersType,
  SubjectPageType,
} from "./SubjectPage.types";
import { useAppDispatch, useAppSelector } from "../../../core/hooks";
import {
  deleteStandardSubject,
  getStandardSubjectList,
  saveStandardSubject,
  updateStandardSubject,
} from "./SubjectPage.action";
import HPRDataGrid from "../../../components/common/HPRDataGrid/HRPDataGrid";
import { PageModeType } from "../../../common/types/common.page.type";
import {
  PaginationDTO,
  SearchParameterDTO,
  SortDropDownDTO,
  StandardSubjectDTO,
} from "../../../common/types/common.dto.types";
import { PageRegistrationProperties } from "../../../core/reducers/pageRegistrationReducer.types";
import usePageRegistration from "../../../core/hooks/usePageRegistration";
import {
  EnumButtonModeType,
  EnumGridDataShowRowCount,
  EnumStatus,
  EnumPageMode,
  EnumPageType,
} from "../../../common/enums/common.enums";
import {
  setPageMode,
  setStandardSubject,
  setStandardSubjectInitState,
  setStandardSubjectSearchParameter,
  setSubjectModalOpen,
} from "./SubjectPage.reducer";
import {
  AddCircle,
  ArrowLeft2,
  ArrowRight2,
  CardSlash,
  CloseCircle,
  Edit,
  SearchNormal1,
} from "iconsax-react";
import { useNavigate } from "react-router-dom";
import { StandardPageParametersType } from "../StandardPage/StandardPage.types";
import { openPopup } from "../../../components/Popups/Popup.reducer";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import HPRSplitButton from "../../../components/common/HPRSplitButton/HPRSplitButton";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import SimpleReactValidator from "simple-react-validator";
import dayjs from "dayjs";
import {
  HPRDataGridToolbarProps,
  HPRGridColDef,
} from "../../../components/common/HPRDataGrid/HPRDataGrid.types";
import {
  EnumSystemFunctions,
  EnumSystemFunctionTypes,
} from "../../../core/reducers/functionRights.types";
import { CheckFunctionRights } from "../../../common/functions/common.functions";

const initialState = {
  PageMode: {
    PageMode: EnumPageMode.Default,
    IsDisable: true,
    IsShowAddBtn: true,
    IsShowEditBtn: false,
    IsShowDeleteBtn: false,
    IsShowCancelBtn: false,
    IsShowSaveBtn: false,
    IsShowUpdateBtn: false,
    IsShowCloseBtn: false,
  } as PageModeType,
  Data: {} as PaginationDTO,
  StandaradSubject: {
    Id: 0,
    Name: "",
    StandardId: 0,
    Version: 1,
    Status: EnumStatus.Published,
  } as StandardSubjectDTO,
  StandardSubjectSearchParameter: {
    StandardSubjectSearchParams: {
      Name: "",
      StandardId: 0,
    } as StandardSubjectDTO,
    IsAdvanceSearch: false,
    SelectedPage: 1,
    GridPageSize: EnumGridDataShowRowCount.GridDataShowRowCount_2,
  } as SearchParameterDTO,
  SubjectModalOpen: false,
  Validator: new SimpleReactValidator({
    messages: {
      default: "This field is required",
    },
  }),
  ShowErrorMsg: false,
  ButtonModeType: EnumButtonModeType.Save,
} as SubjectPageType;

const SubjectPage = (props: PageRegistrationProperties) => {
  usePageRegistration(props);
  // create state for StandardPageType with initialState values
  const [standardSubjectPageState, setstandardSubjectPageState] =
    useState(initialState);

  // pass parameters to page

  const location = useLocation();
  const parameter: SubjectPageParametersType = location.state;

  // use for page navigation
  const navigate = useNavigate();

  const dataFetchedRef = useRef(false);

  const dispatch = useAppDispatch();
  const standardSubjectState = useAppSelector(
    (state) => state.standardSubjectReducer
  );
  const standardState = useAppSelector((state) => state.standardReducer);
  const authState = useAppSelector((state) => state.authReducer);

  //open and close Modal
  const handleOpen = () => {
    dispatch(setSubjectModalOpen(true));
  };
  const handleClose = () => {
    dispatch(setSubjectModalOpen(false));
  };

  const checkSystemFunctionRight = (
    functionId: EnumSystemFunctions,
    functionTypeId: EnumSystemFunctionTypes
  ): boolean => {
    return CheckFunctionRights(
      authState.FunctionRights,
      EnumPageType.Subject,
      functionId,
      functionTypeId
    );
  };

  //=========================================================
  const columns: HPRGridColDef[] = [
    {
      field: "Id",
      headerName: "Id",
      hideColumn: true,
      hideable: false,
      filterable: false,
      flex: 0.5,
    },
    {
      field: "Name-1",
      headerName: "Subject",
      flex: 14,
      valueGetter: (params) => params.row?.Name,
      value: "",
    },
    {
      field: "ModifiedBy-3",
      headerName: "Last modified by",
      flex: 6,
      valueGetter: (params) => params.row?.ModifiedBy,
      value: "",
    },
    {
      field: "ModifiedDate-4",
      headerName: "Last modified date",
      flex: 6,
      valueGetter: (params) =>
        dayjs(params.row?.ModifiedDate).format("DD-MMM-YYYY HH:mm"),
      value: "",
    },
    {
      field: " ",
      flex: 1,
      sortable: false,
      filterable: false,
      hide: parameter?.StatusId === EnumStatus.Deactivated,
      renderCell: (params) => {
        const onClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          dispatch(
            setStandardSubject({
              Id: params.row?.Id,
              Name: params.row?.Name,
              StandardId: parameter?.StandardId,
            } as StandardSubjectDTO)
          );

          setstandardSubjectPageState((values) => {
            return {
              ...values,
              StandaradSubject: {
                ...values.StandaradSubject,
                Name: params.row?.Name,
                Id: params.row?.Id,
              },
            };
          });
          onClickViewBtn();
        };

        return (
          <>
            {checkSystemFunctionRight(
              EnumSystemFunctions.SubjectPage_View_Subject,
              EnumSystemFunctionTypes.ButtonAccess
            ) && (
              <Button
                className="standards-icon-forward align-right flex-valign-middle cursor-pointer grid-icon-btn"
                onClick={onClick}
              >
                <ArrowRight2 size="32" variant="Outline" />
              </Button>
            )}
          </>
        );
      },
    },
  ];

  //Page onload
  useEffect(() => {
    if (parameter?.StandardId > 0) {
      if (dataFetchedRef.current) return;
      dataFetchedRef.current = true;

      dispatch(
        setStandardSubjectInitState({
          ...standardSubjectState,
          StandaradSubject: {
            ...standardSubjectState.StandaradSubject,
            StandardId: parameter.StandardId,
          },
          StandardSubjectSearchParameter: {
            ...standardSubjectState.StandardSubjectSearchParameter,
            StandardSubjectSearchParams: {
              ...standardSubjectState.StandardSubjectSearchParameter
                .StandardSubjectSearchParams,
              StandardId: parameter.StandardId,
              Name: standardSubjectPageState.StandardSubjectSearchParameter
                .StandardSubjectSearchParams.Name,
            },
          },
          Data: {} as PaginationDTO,
        })
      );

      dispatch(
        getStandardSubjectList({
          ...standardSubjectPageState.StandardSubjectSearchParameter,
          StandardSubjectSearchParams: {
            ...standardSubjectPageState.StandardSubjectSearchParameter
              .StandardSubjectSearchParams,
            StandardId: parameter.StandardId,
          },
        })
      );

      setstandardSubjectPageState((values) => {
        return {
          ...values,
          StandaradSubject: {
            ...values.StandaradSubject,
            StandardId: parameter.StandardId,
          },
          StandardSubjectSearchParameter: {
            ...values.StandardSubjectSearchParameter,
            StandardSubjectSearchParams: {
              ...values.StandardSubjectSearchParameter
                .StandardSubjectSearchParams,
              StandardId: parameter.StandardId,
            },
          },
        };
      });
    }
  }, []);

  //when reducer state change
  useEffect(() => {
    if (!dataFetchedRef.current) return;
    setstandardSubjectPageState((values) => {
      return {
        ...values,
        Data: {
          ...values.Data,
          Data: standardSubjectState.Data.Data,
          TotalRecordsCount: standardSubjectState.Data.TotalRecordsCount,
          SelectedPage: standardSubjectState.Data.SelectedPage,
        },
        StandaradSubject: {
          Id: standardSubjectState.StandaradSubject.Id,
          Name: standardSubjectState.StandaradSubject.Name,
          StandardId: parameter.StandardId,
          Version: standardSubjectState.StandaradSubject.Version,
          Status: standardSubjectState.StandaradSubject.Status,
        } as StandardSubjectDTO,
        StandardSubjectSearchParameter: {
          ...values.StandardSubjectSearchParameter,
          SelectedPage: standardSubjectState.Data.SelectedPage,
          SortByNavigation:
            standardSubjectState.StandardSubjectSearchParameter
              .SortByNavigation,
          GridPageSize:
            standardSubjectState.StandardSubjectSearchParameter.GridPageSize,
        },
        SubjectModalOpen: standardSubjectState.SubjectModalOpen,
        PageMode: standardSubjectState.PageMode,
      };
    });
  }, [standardSubjectState]);

  //================================ Search ============================================================

  const onChangeSearchName = (event: ChangeEvent<HTMLInputElement>) => {
    setstandardSubjectPageState((values) => {
      return {
        ...values,
        StandardSubjectSearchParameter: {
          ...values.StandardSubjectSearchParameter,
          StandardSubjectSearchParams: {
            ...values.StandardSubjectSearchParameter
              .StandardSubjectSearchParams,
            Name: event.target.value,
          },
        },
      };
    });

    if (!event.target.value) {
      dispatch(
        getStandardSubjectList({
          ...standardSubjectPageState.StandardSubjectSearchParameter,
          StandardSubjectSearchParams: {
            ...standardSubjectPageState.StandardSubjectSearchParameter
              .StandardSubjectSearchParams,
            Name: "",
          },
        })
      );
    }
  };

  const onChangeStandardSubjectSearchParameter = (
    isAdvanceSearch: boolean,
    selectedPage: number
  ) => {
    dispatch(
      setStandardSubjectSearchParameter({
        ...standardSubjectPageState.StandardSubjectSearchParameter,
        IsAdvanceSearch: isAdvanceSearch,
        SelectedPage: selectedPage,
      })
    );

    dispatch(
      getStandardSubjectList({
        ...standardSubjectPageState.StandardSubjectSearchParameter,
        IsAdvanceSearch: isAdvanceSearch,
        SelectedPage: selectedPage,
      })
    );
  };

  const onKeyPressSearchName = (event: any) => {
    if (event.charCode === 13) {
      event.preventDefault();

      if (
        standardSubjectPageState.StandardSubjectSearchParameter
          .StandardSubjectSearchParams.Name !==
        standardSubjectState.StandardSubjectSearchParameter
          .StandardSubjectSearchParams.Name
      ) {
        onChangeStandardSubjectSearchParameter(
          standardSubjectPageState?.StandardSubjectSearchParameter
            ?.IsAdvanceSearch,
          1 //Default select 1st page
        );
      }
    }
  };

  const serachBtnClick = (IsAdvanceSearch: boolean) => {
    onChangeStandardSubjectSearchParameter(
      IsAdvanceSearch,
      1 //Default select 1st page
    );
  };

  const onPaginationCallBack = (newPage: number) => {
    if (
      standardSubjectPageState.StandardSubjectSearchParameter.SelectedPage !==
      newPage
    ) {
      onChangeStandardSubjectSearchParameter(
        standardSubjectPageState?.StandardSubjectSearchParameter
          ?.IsAdvanceSearch,
        newPage
      );
    }
  };

  const onSortByNavigationCallBack = (
    selectedSortByNavigation: SortDropDownDTO
  ) => {
    dispatch(
      setStandardSubjectSearchParameter({
        ...standardSubjectPageState.StandardSubjectSearchParameter,
        StandardSubjectSearchParams: {
          ...standardSubjectPageState.StandardSubjectSearchParameter
            .StandardSubjectSearchParams,
        },
        SortByNavigation: selectedSortByNavigation,
        SelectedPage: 1,
      })
    );

    dispatch(
      getStandardSubjectList({
        ...standardSubjectPageState.StandardSubjectSearchParameter,
        StandardSubjectSearchParams: {
          ...standardSubjectPageState.StandardSubjectSearchParameter
            .StandardSubjectSearchParams,
        },
        SortByNavigation: selectedSortByNavigation,
        SelectedPage: 1,
      })
    );
  };

  //================================ End Search ============================================================

  const OnSubjectTextChange = (name: string, value: any) => {
    setstandardSubjectPageState((values) => {
      return {
        ...values,
        StandaradSubject: {
          ...values.StandaradSubject,
          Name: value,
        },
      };
    });
  };

  const SaveSubject = (buttonModeType: EnumButtonModeType) => {
    if (IsPageValid()) {
      dispatch(
        saveStandardSubject({
          ...standardSubjectPageState,
          ButtonModeType: buttonModeType,
        })
      );
    }
  };

  const UpdateSubject = (buttonModeType: EnumButtonModeType) => {
    if (IsPageValid()) {
      dispatch(
        updateStandardSubject({
          ...standardSubjectPageState,
          ButtonModeType: buttonModeType,
        })
      );
    }
  };

  const IsPageValid = (): boolean => {
    let isValid = standardSubjectPageState.Validator.allValid();
    if (!isValid) {
      setstandardSubjectPageState((values) => {
        return {
          ...values,
          ShowErrorMsg: !standardSubjectPageState.ShowErrorMsg,
        };
      });

      //show validation message
      standardSubjectPageState.Validator.showMessages();

      return isValid;
    } else {
      //hide validation message
      standardSubjectPageState.Validator.hideMessages();
    }

    return isValid;
  };

  //================ Button functions ===================//
  const onClickCancelBtn = () => {
    //hide validation message
    standardSubjectPageState.Validator.hideMessages();

    if (standardSubjectPageState.PageMode.IsShowEditBtn) {
      dispatch(
        setStandardSubject({
          Id: 0,
          Name: "",
          StandardId: parameter?.StandardId,
          Version: 1,
          Status: EnumStatus.Published,
        } as StandardSubjectDTO)
      );

      dispatch(setPageMode(EnumPageMode.Default));
      handleClose();
    } else if (standardSubjectPageState.PageMode.IsShowSaveBtn) {
      if (
        standardSubjectPageState.StandaradSubject.Name === null ||
        standardSubjectPageState.StandaradSubject.Name.match(/^ *$/) !== null
      ) {
        dispatch(
          setStandardSubject({
            Id: 0,
            Name: "",
            StandardId: parameter?.StandardId,
            Version: 1,
            Status: EnumStatus.Published,
          } as StandardSubjectDTO)
        );
        dispatch(setPageMode(EnumPageMode.Default));
        handleClose();
      } else {
        dispatch(
          openPopup({
            Open: true,
            BodyText: "Do you want to discard the changes?",
            HeaderText: "Confirmation",
            PopupType: EnumPopupType.YesNoConfirmation,
            YesBtnClick() {
              dispatch(
                setStandardSubject({
                  Id: 0,
                  Name: "",
                  StandardId: parameter?.StandardId,
                  Version: 1,
                  Status: EnumStatus.Published,
                } as StandardSubjectDTO)
              );
              dispatch(setPageMode(EnumPageMode.Default));
              handleClose();
            },
          } as PopupProps)
        );
      }
    } else {
      //Check original data changed
      if (
        standardSubjectPageState.StandaradSubject.Name !==
        standardSubjectState.StandaradSubject.Name
      ) {
        dispatch(
          openPopup({
            Open: true,
            BodyText: "Do you want to discard the changes?",
            HeaderText: "Confirmation",
            PopupType: EnumPopupType.YesNoConfirmation,
            YesBtnClick() {
              setstandardSubjectPageState((values) => {
                return {
                  ...values,
                  StandaradSubject: {
                    Id: standardSubjectState.StandaradSubject.Id,
                    Name: standardSubjectState.StandaradSubject.Name,
                    StandardId: parameter?.StandardId,
                    Version: 1,
                    Status: standardSubjectState.StandaradSubject.Status,
                  } as StandardSubjectDTO,
                };
              });
              dispatch(setPageMode(EnumPageMode.ViewMode));
            },
          } as PopupProps)
        );
      } else {
        dispatch(setPageMode(EnumPageMode.ViewMode));
      }
    }
  };

  const CloseButtonClick = () => {
    dispatch(
      setStandardSubject({
        Id: 0,
        Name: "",
        StandardId: parameter?.StandardId,
        Version: 1,
        Status: EnumStatus.Published,
      } as StandardSubjectDTO)
    );
    dispatch(setPageMode(EnumPageMode.Default));
    handleClose();
  };

  const onClickDeleteBtn = () => {
    dispatch(
      openPopup({
        Open: true,
        BodyText: "Are you sure you want to deactivate?",
        HeaderText: "Confirmation",
        PopupType: EnumPopupType.YesNoConfirmation,
        YesBtnClick() {
          if (standardSubjectPageState.StandaradSubject?.Id > 0) {
            dispatch(deleteStandardSubject(standardSubjectPageState));
            //hide validation message
            standardSubjectPageState.Validator.hideMessages();
          }
        },
      } as PopupProps)
    );
  };

  const onClickViewBtn = () => {
    dispatch(setPageMode(EnumPageMode.ViewMode));
    handleOpen();
  };

  const onClickAddBtn = () => {
    dispatch(setPageMode(EnumPageMode.AddMode));
    handleOpen();
  };

  const onClickEditBtn = () => {
    dispatch(setPageMode(EnumPageMode.EditMode));
  };

  //================ End Button functions ===================//
  // modal popup
  const style = {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  //------------------------------------
  return (
    <>
      {/* <Grid container columns={12} className="global-header-wrap"> */}
      {/* <Grid item xs={12} className="">
          <h1>{props.PageTitle + "s"}</h1>
        </Grid> */}
      {/* </Grid> */}
      <div className="content-section-card">
        <Grid container>
          {/* Button bar */}
          <div className="flex--container width100-p top-main-border-inner global-subhead-btn-wrap">
            <div className="flex__item--inherit pr-10">
              <Button
                aria-label="back"
                className="sub-head-back-btn back"
                onClick={() => {
                  navigate("/standard", {
                    state: {
                      StandardId: parameter?.StandardId,
                    } as StandardPageParametersType,
                  });
                }}
                title="Back to home page"
              >
                {/* <ArrowLeft2 size="24" variant="Outline" /> */}
                <ArrowBackIosNewOutlinedIcon className="" />
                <span className="body-bold secondary-color">Back</span>
              </Button>{" "}
            </div>
            <div className="">
              <h1 className="page_title">{props.PageTitle + "s"}</h1>
            </div>
            <div className="flex__item search-bar--small ml-10 mr-10">
              <Paper
                component="form"
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <InputBase
                  value={
                    standardSubjectPageState.StandardSubjectSearchParameter
                      .StandardSubjectSearchParams?.Name
                  }
                  onChange={onChangeSearchName}
                  onKeyPress={onKeyPressSearchName}
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search by Subject"
                  inputProps={{ "aria-label": "Subject" }}
                  type="search"
                />
                <IconButton
                  onClick={() => {
                    serachBtnClick(false);
                  }}
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                  className="m-0"
                >
                  <SearchNormal1
                    variant="Outline"
                    className="ico-secondary"
                    size={18}
                  />
                </IconButton>
                {/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton
                    onClick={() => {
                      serachBtnClick(true);
                    }}
                    color="primary"
                    sx={{ p: "10px" }}
                    aria-label="directions"
                  >
                    <Filter variant="Outline" className="ico-secondary" />
                  </IconButton> */}
                {/* <IconButton
                    onClick={() => {
                      serachBtnClick(false);
                    }}
                    type="button"
                    sx={{ p: "10px" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                  <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton
                    onClick={() => {
                      serachBtnClick(true);
                    }}
                    color="primary"
                    sx={{ p: "10px" }}
                    aria-label="directions"
                  >
                    <FilterAltOutlinedIcon />
                  </IconButton> */}
              </Paper>
            </div>
            {checkSystemFunctionRight(
              EnumSystemFunctions.SubjectPage_Add_New_Subject,
              EnumSystemFunctionTypes.ButtonAccess
            ) && (
              <Button
                className="primary-btn-small"
                size="small"
                disableElevation
                variant="outlined"
                startIcon={<AddCircle variant="Outline" />}
                onClick={onClickAddBtn}
                style={{
                  visibility:
                    standardSubjectPageState?.PageMode?.IsShowAddBtn &&
                    parameter?.StatusId !== EnumStatus.Deactivated
                      ? "visible"
                      : "hidden",
                }}
              >
                Add
              </Button>
            )}
          </div>

          <Grid container></Grid>
          <Grid container>
            <Modal
              className="modal-outter sub-form-section"
              open={standardSubjectPageState.SubjectModalOpen}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <div className="modal-header">
                  <h1>
                    <span>Subject</span>
                    <span>
                      {standardSubjectPageState.PageMode.IsShowSaveBtn ? (
                        <>
                          <HPRSplitButton
                            Name="SubjectSave"
                            ButtonOptions={[
                              {
                                ButtonId: "0",
                                ButtonName: "Save",
                                onButtonClickCallBack: () => {
                                  SaveSubject(EnumButtonModeType.Save);
                                },
                              },
                              {
                                ButtonId: "1",
                                ButtonName: "Save & Close",
                                onButtonClickCallBack: () => {
                                  SaveSubject(EnumButtonModeType.SaveAndClose);
                                },
                              },
                              {
                                ButtonId: "2",
                                ButtonName: "Save & Continue",
                                onButtonClickCallBack: () => {
                                  SaveSubject(
                                    EnumButtonModeType.SaveAndContinue
                                  );
                                },
                              },
                            ]}
                          ></HPRSplitButton>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSubjectPageState.PageMode.IsShowUpdateBtn ? (
                        <>
                          <HPRSplitButton
                            Name="SubjectUpdateBtn"
                            ButtonOptions={[
                              {
                                ButtonId: "0",
                                ButtonName: "Update & Close",
                                onButtonClickCallBack: () => {
                                  UpdateSubject(
                                    EnumButtonModeType.UpdateAndClose
                                  );
                                },
                              },
                              {
                                ButtonId: "1",
                                ButtonName: "Update",
                                onButtonClickCallBack: () => {
                                  UpdateSubject(EnumButtonModeType.Update);
                                },
                              },
                            ]}
                          ></HPRSplitButton>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSubjectPageState.PageMode.IsShowEditBtn &&
                      checkSystemFunctionRight(
                        EnumSystemFunctions.SubjectPage_Edit_Subject,
                        EnumSystemFunctionTypes.ButtonAccess
                      ) ? (
                        <>
                          <Button
                            className="primary-btn-small"
                            size="small"
                            variant="outlined"
                            disableElevation
                            onClick={onClickEditBtn}
                            startIcon={<Edit variant="Outline" />}
                          >
                            Edit
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSubjectPageState.PageMode.IsShowDeleteBtn &&
                      checkSystemFunctionRight(
                        EnumSystemFunctions.SubjectPage_Deactivate_Subject,
                        EnumSystemFunctionTypes.ButtonAccess
                      ) ? (
                        <>
                          <Button
                            className="primary-btn-small"
                            size="small"
                            variant="outlined"
                            disableElevation
                            startIcon={<CardSlash variant="Outline" />}
                            onClick={onClickDeleteBtn}
                          >
                            Deactivate
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSubjectPageState.PageMode.IsShowCancelBtn ? (
                        <>
                          {" "}
                          <Button
                            className="secondary-btn-small"
                            size="small"
                            variant="outlined"
                            startIcon={<CloseCircle variant="Outline" />}
                            onClick={onClickCancelBtn}
                          >
                            Cancel
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSubjectPageState.PageMode.IsShowCloseBtn && (
                        <Button
                          className="secondary-btn-small"
                          size="small"
                          variant="outlined"
                          disableElevation
                          onClick={CloseButtonClick}
                          startIcon={<CloseCircle variant="Outline" />}
                        >
                          Close
                        </Button>
                      )}
                    </span>
                  </h1>
                </div>
                <div className="modal-content">
                  <Grid container>
                    <Grid
                      item
                      xl={6}
                      lg={6}
                      md={8}
                      sm={12}
                      xs={12}
                      className="m-auto"
                    >
                      <div className="form-group">
                        <HPRTextBox
                          Id=""
                          Label="Subject"
                          Name="subject"
                          Value={
                            standardSubjectPageState?.StandaradSubject.Name
                          }
                          Type={EnumTextBoxType.Text}
                          Disabled={standardSubjectPageState.PageMode.IsDisable}
                          onTextBoxChange={OnSubjectTextChange}
                          Validator={standardSubjectPageState.Validator}
                          Rules={"required"}
                          IsEnableValidator={true}
                          AutoFocus={
                            !standardSubjectPageState.PageMode.IsDisable
                          }
                          Required={true}
                          InputProps={{ maxLength: 250 }}
                        ></HPRTextBox>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Box>
            </Modal>

            <div className="HPRDataGrid-wrapper content-inner-wrap pl-10 pr-10">
              <HPRDataGrid
                Columns={columns}
                Data={standardSubjectPageState?.Data?.Data}
                TotalRecordsCount={
                  standardSubjectPageState?.Data?.TotalRecordsCount
                }
                //onRowClickedCallBack={onSubjectGridRowClickedCallBack}
                AutoHeight={true}
                onPaginationChangeCallBack={onPaginationCallBack}
                SelectedPage={standardSubjectPageState.Data?.SelectedPage}
                HPRDataGridToolbarProps={
                  {
                    ShowTotalRecordsCount: true,
                  } as HPRDataGridToolbarProps
                }
                PageSize={
                  standardSubjectPageState?.StandardSubjectSearchParameter
                    ?.GridPageSize ??
                  EnumGridDataShowRowCount.GridDataShowRowCount_2
                }
                MenuFunctions={{
                  onChangeSortBy: onSortByNavigationCallBack,
                }}
                ShowCustomePagination
              ></HPRDataGrid>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default SubjectPage;
